module.exports = __webpack_public_path__ + "static/media/artificial-intelligence.bc931ed5.svg";